import * as React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

import {
    Typography,
} from '@material-ui/core';
import TaskElementLink from '../../../youwell-common/components/taskElements/TaskElementLink';
import { getVideos } from '../../../youwell-common/htmlUtils';
import { linkTypes } from '../../../youwell-common/constants';
import { HtmlContent } from '../../../youwell-common/components';

const styles = theme => ({
    root: {
    },
    elementHeading: {
        borderBottom: theme.borders.normal,
        borderBottomColor: theme.palette.secondary.main,
        borderBottomWidth: 4,
        display: 'flex',
        alignItems: 'center',
    },
    elementHeadingTitle: {
        flex: '1 1 auto',
    },
    videos: {
        display: 'flex',
        marginTop: theme.spacing(4),

        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
        },
    },
    video: {
        flex: '0 1 50%',
        '&:first-child': {
            paddingRight: theme.spacing(2),

            [theme.breakpoints.down('xs')]: {
                paddingRight: 0,
            },
        },
        '&:last-child': {
            paddingLeft: theme.spacing(2),
            [theme.breakpoints.down('xs')]: {
                paddingLeft: 0,
            },
        },

        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(0, 0, 2),
        },
    },
    noVideos: {
        margin: theme.spacing(2),
    },
    description: {
        marginBottom: theme.spacing(1),
        color: theme.colors.blue4,
    },
});

const getTaskVideosFromHtmlContent = task => (task && task.contentElements && task.contentElements.reduce((prev, curr) => [...prev, ...getVideos(curr.htmlContent)], [])) || [];
const getTaskVideosFromLink = task => (task && task.contentElements && task.contentElements.reduce((prev, curr) => (curr.link && (curr.link.linkType === linkTypes.youtube || curr.link.linkType === linkTypes.vimeo || curr.link.linkType === linkTypes.video)
    ? [...prev, { Component: <TaskElementLink link={curr.link} /> }] : prev), [])) || [];

const getTaskVideos = (task) => {
    const videos = [];
    videos.push(...getTaskVideosFromHtmlContent(task).map(html => ({ html })));
    videos.push(...getTaskVideosFromLink(task));
    return videos;
};

const getDescriptionContent = task => task?.contentElements?.find(d => d.htmlContent)?.htmlContent;

const VideoListing = ({ classes, translate, task }) => {
    if (!task) {
        return null;
    }

    const descriptionContent = getDescriptionContent(task);

    return (
        <div className={classes.root}>
            <Typography variant="h4" color="primary" gutterBottom>
                {task.name}
            </Typography>

            {descriptionContent && (
                <HtmlContent html={descriptionContent} className={classes.description} />
            )}
            <div className={classes.videos}>
                {getTaskVideos(task).map((video, cI) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <React.Fragment key={cI}>
                        {video.html && (
                            /* eslint-disable react/no-danger */
                            <div dangerouslySetInnerHTML={{ __html: video.html }} className={classes.video} />
                            /* eslint-enable react/no-danger */
                        )}
                        {video.Component && (
                            <div className={classes.video}>
                                {video.Component}
                            </div>
                        )}
                        {video.none && (
                            <Typography variant="subtitle2" color="textSecondary" className={classes.noVideos}>
                                {translate('videos.noVideosForModule')}
                            </Typography>
                        )}
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
};

VideoListing.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    task: PropTypes.object,
};

VideoListing.defaultProps = {
    task: null,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
});


export default connect(mapStateToProps)(withStyles(styles)(VideoListing));
